import React from 'react'
import {
  ICustomerStoriesCardWithFilters as ICustomerStoryCard,
  CustomerStoryCard,
} from 'marketing-site/src/library/elements/CustomerStoryCard'
import {
  ICustomerCard as IContentfulCustomerStoryCard,
  ICustomerStoryIndustry as IContentfulCustomerStoryIndustry,
  ICustomerStorySolution as IContentfulCustomerStorySolution,
} from 'marketing-site/@types/generated/contentful'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { transformImage } from '../elements/ContentfulImage'
import { transformLogo } from '../elements/ContentfulLogo'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulCustomerStoryCard = (customerStoryCard: IContentfulCustomerStoryCard) => {
  return (
    <EntryMarker entry={customerStoryCard}>
      {() => <CustomerStoryCard {...transformCustomerStoryCard(customerStoryCard)} />}
    </EntryMarker>
  )
}

export function transformCustomerStoryCard(
  customerStoryCard: IContentfulCustomerStoryCard,
): ICustomerStoryCard {
  return {
    ...customerStoryCard.fields,
    title: documentToHtmlString(customerStoryCard.fields.title),
    image: transformImage(customerStoryCard.fields.image),
    logo: transformLogo(customerStoryCard.fields.logo),
    industries:
      customerStoryCard.fields.industries &&
      customerStoryCard.fields.industries.map((industry) =>
        transformCustomerStoryIndustry(industry),
      ),
    solutions:
      customerStoryCard.fields.solutions &&
      customerStoryCard.fields.solutions.map((solution) =>
        transformCustomerStorySolution(solution),
      ),
    snapshotImage: transformLogo(customerStoryCard.fields.snapshotImage),
    snapshotBody:
      customerStoryCard.fields.snapshotBody &&
      documentToHtmlString(customerStoryCard.fields.snapshotBody),
    snapshotSidebar:
      customerStoryCard.fields.snapshotSidebar &&
      documentToHtmlString(customerStoryCard.fields.snapshotSidebar),
  }
}

export function transformCustomerStoryIndustry(
  customerStoryIndustry: IContentfulCustomerStoryIndustry,
) {
  return {
    ...customerStoryIndustry.fields,
  }
}

export function transformCustomerStorySolution(
  customerStorySolution: IContentfulCustomerStorySolution,
) {
  return {
    ...customerStorySolution.fields,
  }
}
